<div class="complaint-meeting-form" [class.mobile]="!deviceService.isDesktop()">
  <div class="content-bg">
    <div class="top">
      <div class="cover-wrap">
        <on-ui-cover [cover]="cover"></on-ui-cover>
        <div class="type" [ngClass]="meetingServiceType[meeting?.type]">{{ type | translate }}</div>
      </div>
      <p class="subject">{{subject}}</p>
      <p class="title">{{meeting?.title}}</p>
    </div>
    <div class="bottom">
      <span class="tutor-label">{{'dashboard.nearest-meet-widget.tutor' | translate}}:</span>
      <div class="avatar-wrap">
        <on-ui-cover [cover]="avatar"></on-ui-cover>
      </div>
      <span class="author-name">{{authorFullName}}</span>
    </div>
  </div>

  <div *ngIf="!complainSent && !complainError" class="content">
    <div class="top">
      <p class="complain-title">{{'meeting-complaint-form.title' | translate}}</p>
      <p class="complain-hint">{{'meeting-complaint-form.text' | translate}}</p>

      <div class="text-wrap">
        <p class="complain-label" [translate]="'meeting-complaint-form.comment-moderator'"></p>
        <on-ui-textarea [(ngModel)]="meetingComplaint.comment"></on-ui-textarea>
      </div>
    </div>

    <div class="bottom">
      <div class="sent-actions">
        <on-ui-button label="meeting-complaint-form.send-complaint"
                      class="primary"
                      [disabled]="!meetingComplaint.comment"
                      (onclick)="submitComplaint()">
        </on-ui-button>
      </div>
    </div>
  </div>

  <div *ngIf="complainSent" class="content complaint-sent">
    <div class="complaint-info">
      <app-icon width="90" height="90" icon="complaint"></app-icon>
      <p class="complain-sent-text" [translate]="'meeting-complaint-form.sent-text'"></p>
      <p class="complain-sent-text-check" [translate]="'meeting-complaint-form.sent-text-check'"></p>
      <a class="complain-email-link-check" [routerLink]="'/profile/contacts'" target="_blank">{{emailCheckLink}}</a>
    </div>
  </div>

  <div *ngIf="complainError" class="content content-error">
    <app-icon width="187" height="123" file="complaint" icon="error"></app-icon>
    <span class="error-text" [translate]="'meeting-complaint-form.error-text'"></span>

    <on-ui-button label="meeting-complaint-form.again" class="primary outline"
                  (onclick)="reset()">
    </on-ui-button>
  </div>
</div>
